import * as THREE from 'three';

/** Etiqueta flotante con nombre, etiqueta numérica y nivel (sprite de canvas). */
export function makeNametag(name: string, tag: string, level: number, opts: { host?: boolean; me?: boolean } = {}): THREE.Sprite {
  const c = document.createElement('canvas');
  c.width = 512;
  c.height = 128;
  const ctx = c.getContext('2d')!;
  const label = `${opts.host ? '👑 ' : ''}${name}`;
  const nameFont = '800 46px "Baloo 2", "Trebuchet MS", sans-serif';
  const tagFont = '700 26px sans-serif';
  ctx.font = nameFont;
  const nameW = ctx.measureText(label).width;
  ctx.font = tagFont;
  const tagW = ctx.measureText(`#${tag}`).width;
  const w = Math.min(504, 86 + nameW + 10 + tagW + 26);
  const x0 = (512 - w) / 2;
  ctx.fillStyle = opts.me ? 'rgba(255, 0, 110, 0.85)' : 'rgba(20, 20, 40, 0.7)';
  ctx.beginPath();
  ctx.roundRect(x0, 20, w, 84, 42);
  ctx.fill();
  ctx.fillStyle = '#ffd60a';
  ctx.beginPath();
  ctx.arc(x0 + 44, 62, 30, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#1b1b2f';
  ctx.font = '900 34px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(String(level), x0 + 44, 64);
  ctx.textAlign = 'left';
  ctx.fillStyle = '#ffffff';
  ctx.font = nameFont;
  ctx.fillText(label, x0 + 86, 60, w - 86 - tagW - 36);
  ctx.fillStyle = 'rgba(255,255,255,0.65)';
  ctx.font = tagFont;
  ctx.fillText(`#${tag}`, x0 + w - 24 - tagW, 64);
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  const s = new THREE.Sprite(new THREE.SpriteMaterial({ map: tex, depthTest: false, transparent: true }));
  s.scale.set(2.4, 0.6, 1);
  s.renderOrder = 10;
  return s;
}

/** Bocadillo temporal sobre un personaje (mensajes de chat y emotes). */
export function makeBubble(text: string): THREE.Sprite {
  const c = document.createElement('canvas');
  c.width = 512;
  c.height = 160;
  const ctx = c.getContext('2d')!;
  ctx.font = '700 40px "Baloo 2", sans-serif';
  let t = text;
  while (ctx.measureText(t).width > 440 && t.length > 4) t = t.slice(0, -2);
  if (t !== text) t += '…';
  const w = ctx.measureText(t).width + 60;
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.roundRect((512 - w) / 2, 10, w, 100, 30);
  ctx.moveTo(236, 110);
  ctx.lineTo(256, 145);
  ctx.lineTo(276, 110);
  ctx.fill();
  ctx.fillStyle = '#1b1b2f';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(t, 256, 62);
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  const s = new THREE.Sprite(new THREE.SpriteMaterial({ map: tex, depthTest: false, transparent: true }));
  s.scale.set(2.6, 0.8, 1);
  s.renderOrder = 11;
  return s;
}
